import { LEARNING_GOAL_OPTIONS, ROLE_OPTIONS_TYPE } from 'bundles/onboarding-common/constants';
import type { LearnerProfileDesiredSkillsQuery } from 'bundles/onboarding-common/queries/__generated__/LearnerProfileDesiredSkills';
import type { LearnerProfileLearningGoalQueryQuery } from 'bundles/onboarding-common/queries/__generated__/LearnerProfileLearningGoal';
import type { LearnerProfileOccupationPreferencesQueryQuery } from 'bundles/onboarding-common/queries/__generated__/LearnerProfileOccupationPreferences';
import type { Skill } from 'bundles/onboarding-common/types';
import { slugifyCustomRoleName } from 'bundles/onboarding-common/utils';

const formatLearningGoalFromLearnerProfile = (learningGoalData?: LearnerProfileLearningGoalQueryQuery) => {
  switch (learningGoalData?.LearnerProfile?.me?.learningPrograms?.learningGoal) {
    case 'CHANGE_CAREER':
      return LEARNING_GOAL_OPTIONS.LEARNING_GOAL_CHANGE_CAREER;
    case 'IMPROVE_SKILLS':
      return LEARNING_GOAL_OPTIONS.LEARNING_GOAL_IMPROVE_SKILLS;
    case 'LAND_NEW_JOB':
      return LEARNING_GOAL_OPTIONS.LEARNING_GOAL_LAND_NEW_JOB;
    case 'PERSONAL_INTEREST':
      return LEARNING_GOAL_OPTIONS.LEARNING_GOAL_PERSONAL_INTEREST;
    default:
      return null;
  }
};

const formatOccupationPreferencesFromLearnerProfile = (
  occupationPreferencesData?: LearnerProfileOccupationPreferencesQueryQuery
) => {
  const value =
    occupationPreferencesData?.LearnerProfile?.me?.occupationPreferences?.map((occupationPreference) => {
      if (occupationPreference.occupation.__typename === 'LearnerProfile_OccupationId') {
        return {
          id: occupationPreference.occupation.id,
          name: '',
          type: ROLE_OPTIONS_TYPE.DEFAULT,
        };
      } else {
        return {
          name: occupationPreference.occupation.name,
          id: slugifyCustomRoleName(occupationPreference.occupation.name),
          type: ROLE_OPTIONS_TYPE.CUSTOM,
        };
      }
    }) || null;

  return value;
};

const formatSkillsWantedFromLearnerProfile = (skillsWantedData?: LearnerProfileDesiredSkillsQuery) => {
  const value =
    skillsWantedData?.LearnerProfile?.me?.desiredSkills?.reduce<Skill[]>((acc, skill) => {
      if (skill.__typename === 'Skill_Skill') {
        return [
          ...acc,
          {
            id: skill.id,
            skillName: skill.skillName,
          },
        ];
      } else {
        return acc;
      }
    }, []) || null;

  return value;
};

export {
  formatLearningGoalFromLearnerProfile,
  formatSkillsWantedFromLearnerProfile,
  formatOccupationPreferencesFromLearnerProfile,
};
